import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-0 md:grid-cols-2 gap-x-6 gap-y-4" }
const _hoisted_2 = { class: "bg-phone px-4 md:px-10 py-6 md:py-10 rounded-md" }
const _hoisted_3 = { class: "w-full lg:w-1/2" }
const _hoisted_4 = { class: "text-white font-poppins text-lg py-4 my-0 mb-10" }
const _hoisted_5 = { class: "w-full md:max-w-48 flex rounded-full bg-gradient-to-tr from-brand-primary-dark to-brand-primary-light p-0.5 shadow-md" }
const _hoisted_6 = { class: "flex-1 text-lg md:text-18 bg-transparent px-6 py-3 rounded-full font-poppins border-none hover:cursor-pointer" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "bg-email px-4 md:px-10 py-6 md:py-10 rounded-md" }
const _hoisted_9 = { class: "w-full lg:w-1/2" }
const _hoisted_10 = { class: "text-white font-poppins text-lg py-4 my-0 mb-10" }
const _hoisted_11 = { class: "w-full md:max-w-48 flex rounded-full bg-gradient-to-tr from-brand-primary-dark to-brand-primary-light p-0.5 shadow-md" }
const _hoisted_12 = ["href"]

import { RenderFunction } from 'vue';
import {
  PhoneIcon,
  MailIcon,
  HomeIcon
} from '@heroicons/vue/outline';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';
import { Brand } from '../../services/integration/enums';

type Feature = {
  name: string,
  icon: string|RenderFunction,
  description: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HelpOptions2',
  props: {
    features: {}
  },
  setup(__props: any) {

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

const props = __props;

props.features.forEach(feature => {
  if (feature.icon === 'MailIcon') {
    feature.icon = MailIcon;
  } else if (feature.icon === 'PhoneIcon') {
    feature.icon = PhoneIcon;
  } else if (feature.icon === 'HomeIcon') {
    feature.icon = HomeIcon;
  }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"relative grid grid-cols-0 md:grid-cols-6 text-center bg-white py-10 lg:py-20\" data-v-0c17d301><div class=\"col-span-4 col-start-1 gap-x-12\" data-v-0c17d301><div class=\"text-left col-start-1 flex flex-col\" data-v-0c17d301><p class=\"text-14 text-black font-poppins tracking-widest my-0 py-0\" data-v-0c17d301>CONTACT</p><img class=\"w-1/3 py-2 my-0\" src=\"https://uniti-bpo-website-assets.assets.unitiinternet.com/NEX/help-txt.png\" data-v-0c17d301><p class=\"text-lg text-black font-poppins tracking-normal my-0 py-0\" data-v-0c17d301>We&#39;re here for you - choose any help option below.</p></div></div><div class=\"col-span-1 text-16 font-black text-left pt-10 justify-end\" data-v-0c17d301><p class=\"font-poppins-bold text-md\" data-v-0c17d301>Customer Service</p><p class=\"font-poppins font-bold my-0\" data-v-0c17d301>Monday - Friday</p><p class=\"font-poppins font-thin my-0\" data-v-0c17d301>8:30am - 6pm AEDT</p><p class=\"font-poppins font-bold pt-4 my-0\" data-v-0c17d301>Saturday, Sunday &amp; National Public Holidays</p><p class=\"font-poppins font-thin my-0\" data-v-0c17d301>Closed</p></div><div class=\"col-span-1 text-16 font-black text-left pt-10 justify-end pl-8\" data-v-0c17d301><p class=\"font-poppins-bold text-md\" data-v-0c17d301>Technical Support</p><p class=\"font-poppins font-bold my-0\" data-v-0c17d301>Monday - Friday</p><p class=\"font-poppins font-thin my-0\" data-v-0c17d301>8am - 9pm AEDT</p><p class=\"font-poppins font-bold pt-4 my-0\" data-v-0c17d301>Saturday &amp; Sunday</p><p class=\"font-poppins font-thin my-0\" data-v-0c17d301>9am - 9pm AEDT</p><p class=\"font-poppins font-bold pt-4 my-0\" data-v-0c17d301>National Public Holidays</p><p class=\"font-poppins font-thin my-0\" data-v-0c17d301>Closed</p></div></div>", 1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "font-poppins-bold text-3xl text-white leading-tight py-0 my-0" }, [
            _createTextVNode("Here for you"),
            _createElementVNode("br"),
            _createTextVNode(" on the phone")
          ], -1)),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(brandService).getSupportPhoneNumber()), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", _hoisted_6, [
              _createElementVNode("a", {
                class: "no-underline text-black hover:text-white",
                href: `tel:${_unref(brandService).getSalesPhoneNumber()}`
              }, "Call us Now", 8, _hoisted_7)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "font-poppins-bold text-3xl text-white leading-tight py-0 my-0" }, [
            _createTextVNode("Here for you"),
            _createElementVNode("br"),
            _createTextVNode("by email")
          ], -1)),
          _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(brandService).getSupportEmail()), 1),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              class: "flex-1 text-lg md:text-18 bg-transparent px-6 py-3 rounded-full font-poppins border-none hover:cursor-pointer",
              "on:onClick": _cache[0] || (_cache[0] = ($event: any) => ('mailto:' + _unref(brandService).getSupportEmail()))
            }, [
              _createElementVNode("a", {
                class: "no-underline text-black hover:text-white",
                href: `mailto:${_unref(brandService).getSupportEmail()}`
              }, "Email us Now", 8, _hoisted_12)
            ], 32)
          ])
        ])
      ])
    ])
  ], 64))
}
}

})